import { isEmpty } from 'lodash'
import { login, loginSso, loginAsCustomer, getLogo } from 'helpers/auth'
import { LOGIN, LOGIN_AS_CUSTOMER, EXIT_AS_CUSTOMER, REFRESH_TOKEN } from 'reducers/auth'
import { createPost } from 'helpers/api'
import i18n from 'actions/i18n'
import entityNames from 'options/entityNames'
import { setSessionItem, getSessionItem, removeSessionItem } from 'helpers/sessionStorage'
import {
  I18N_SESSION_KEY,
  REFRESH_TOKEN_SESSION_KEY,
  REFRESH_TOKEN_INTERVAL,
  USER_LOGGED_IN_SESSION_KEY,
  IMPERSONATION_SOURCE_URL,
} from 'options/auth'
import { tryParseDate } from 'helpers/dateTime'

export default {
  login:
    ({ tenant, userName, password, startupEntityName, startupEntityId, accessToken, idToken }) =>
    async (dispatch) => {
      sessionStorage.clear()

      const response = await dispatch({
        type: LOGIN,
        payload:
          accessToken && idToken
            ? loginSso({ tenant, accessToken, idToken })
            : login({ tenant, userName, password }),
      })

      setSessionItem(REFRESH_TOKEN_SESSION_KEY, new Date().toJSON())
      setSessionItem(USER_LOGGED_IN_SESSION_KEY, new Date().toJSON())

      await Promise.all([
        dispatch(i18n.getTranslations(response.value.data.user.languageCode)),
        dispatch(getLogo(response.value.data.tenant)).catch(() => {}),
      ])

      return response
    },

  loginAsCustomer: (customerId) => async (dispatch) => {
    window.impersonationInProgress = true

    const response = await dispatch({
      type: LOGIN_AS_CUSTOMER,
      payload: loginAsCustomer(customerId),
    })

    await dispatch(getLogo(response.value.data.tenant)).catch(() => {})

    return response
  },

  // NOTE: Bypassing the redux store
  tryLoginAsCustomer: (customerId) => (dispatch) =>
    dispatch({
      type: `TRY_${LOGIN_AS_CUSTOMER}`,
      payload: loginAsCustomer(customerId),
    }),

  exitAsCustomer: () => async (dispatch, getState) => {
    window.impersonationInProgress = true

    removeSessionItem(I18N_SESSION_KEY)

    await dispatch({ type: EXIT_AS_CUSTOMER })

    window.location.href = IMPERSONATION_SOURCE_URL
  },

  refreshToken: (mustRefresh) => async (dispatch, getState) => {
    let response

    const shouldRefresh = () => {
      const lastTime = tryParseDate(getSessionItem(REFRESH_TOKEN_SESSION_KEY))
      const elapsedTime = lastTime ? Date.now() - lastTime.getTime() : REFRESH_TOKEN_INTERVAL + 1
      return elapsedTime > REFRESH_TOKEN_INTERVAL && !window.refreshTokenInProgress
    }

    if (mustRefresh || shouldRefresh()) {
      try {
        window.refreshTokenInProgress = true

        response = await dispatch({
          type: REFRESH_TOKEN,
          payload: createPost(entityNames.users, { action: 'refreshToken' })(),
        })

        if (mustRefresh) {
          await Promise.all([
            dispatch(i18n.getTranslations(response.value.data.user.languageCode)),
            dispatch(getLogo(response.value.data.tenant)).catch(() => {}),
          ])
        }

        setSessionItem(REFRESH_TOKEN_SESSION_KEY, new Date().toJSON())

        if (isEmpty(response.value.data.menuItems)) {
          window.location.href = '/'
        }
      } finally {
        window.refreshTokenInProgress = false
      }
    }

    return response
  },
}
